'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.appWithTranslation = void 0;

var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));

var _regenerator = _interopRequireDefault(require('@babel/runtime/regenerator'));

var _asyncToGenerator2 = _interopRequireDefault(require('@babel/runtime/helpers/asyncToGenerator'));

var _classCallCheck2 = _interopRequireDefault(require('@babel/runtime/helpers/classCallCheck'));

var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'));

var _inherits2 = _interopRequireDefault(require('@babel/runtime/helpers/inherits'));

var _possibleConstructorReturn2 = _interopRequireDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));

var _getPrototypeOf2 = _interopRequireDefault(require('@babel/runtime/helpers/getPrototypeOf'));

var _react = _interopRequireDefault(require('react'));

var _router = require('next/router');

var _hoistNonReactStatics = _interopRequireDefault(require('hoist-non-react-statics'));

var _reactI18next = require('react-i18next');

var _utils = require('../utils');

var _components = require('../components');

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2['default'])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2['default'])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2['default'])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2['default'])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var WrappedComponentWithSSR = (0, _reactI18next.withSSR)()(WrappedComponent);
  var config = this.config,
    consoleMessage = this.consoleMessage,
    i18n = this.i18n;

  var clientLoadNamespaces = function clientLoadNamespaces(lng, namespaces) {
    return Promise.all(
      namespaces
        .filter(function (ns) {
          return !i18n.hasResourceBundle(lng, ns);
        })
        .map(function (ns) {
          return i18n.reloadResources(lng, ns);
        })
    );
  };

  var AppWithTranslation = /*#__PURE__*/ (function (_React$Component) {
    (0, _inherits2['default'])(AppWithTranslation, _React$Component);

    var _super = _createSuper(AppWithTranslation);

    function AppWithTranslation(props) {
      var _this;

      (0, _classCallCheck2['default'])(this, AppWithTranslation);
      _this = _super.call(this, props);

      if (!(0, _utils.isServer)()) {
        var changeLanguageCallback = function changeLanguageCallback(prevLng, newLng) {
          var router = props.router;
          var pathname = router.pathname,
            asPath = router.asPath,
            query = router.query;
          var routeInfo = {
            pathname: pathname,
            query: query,
          };

          if (i18n.initializedLanguageOnce && typeof newLng === 'string' && prevLng !== newLng) {
            var _lngPathCorrector = (0, _utils.lngPathCorrector)(
                config,
                {
                  as: asPath,
                  href: routeInfo,
                },
                newLng
              ),
              as = _lngPathCorrector.as,
              href = _lngPathCorrector.href;

            router.replace(href, as, {
              shallow: config.shallowRender,
            });
          }
        };

        var changeLanguage = i18n.changeLanguage.bind(i18n);

        i18n.changeLanguage = /*#__PURE__*/ (function () {
          var _ref = (0, _asyncToGenerator2['default'])(
            /*#__PURE__*/ _regenerator['default'].mark(function _callee(newLng) {
              var callback,
                prevLng,
                usedNamespaces,
                _args = arguments;
              return _regenerator['default'].wrap(function _callee$(_context) {
                while (1) {
                  switch ((_context.prev = _context.next)) {
                    case 0:
                      callback =
                        _args.length > 1 && _args[1] !== undefined
                          ? _args[1]
                          : function () {
                              return null;
                            };
                      prevLng = i18n.language;

                      if (!(typeof newLng === 'string' && i18n.initializedLanguageOnce === true)) {
                        _context.next = 6;
                        break;
                      }

                      usedNamespaces = Object.entries(i18n.reportNamespaces.usedNamespaces)
                        .filter(function (x) {
                          return x[1] === true;
                        })
                        .map(function (x) {
                          return x[0];
                        });
                      _context.next = 6;
                      return clientLoadNamespaces(newLng, usedNamespaces);

                    case 6:
                      return _context.abrupt(
                        'return',
                        changeLanguage(newLng, function () {
                          changeLanguageCallback(prevLng, newLng);
                          callback();
                        })
                      );

                    case 7:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee);
            })
          );

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        })();
      }

      return _this;
    }

    (0, _createClass2['default'])(
      AppWithTranslation,
      [
        {
          key: 'render',
          value: function render() {
            var _this$props = this.props,
              initialLanguage = _this$props.initialLanguage,
              initialI18nStore = _this$props.initialI18nStore,
              i18nServerInstance = _this$props.i18nServerInstance;
            return _react['default'].createElement(
              _reactI18next.I18nextProvider,
              {
                i18n: i18nServerInstance || i18n,
              },
              _react['default'].createElement(
                _components.NextStaticProvider,
                null,
                _react['default'].createElement(
                  WrappedComponentWithSSR,
                  _extends(
                    {
                      initialLanguage: initialLanguage,
                      initialI18nStore: initialI18nStore,
                    },
                    this.props
                  )
                )
              )
            );
          },
        },
      ],
      [
        {
          key: 'getInitialProps',
          value: (function () {
            var _getInitialProps = (0, _asyncToGenerator2['default'])(
              /*#__PURE__*/ _regenerator['default'].mark(function _callee2(ctx) {
                var wrappedComponentProps,
                  req,
                  initialI18nStore,
                  initialLanguage,
                  i18nServerInstance,
                  namespacesRequired,
                  fallbackLng,
                  languagesToLoad;
                return _regenerator['default'].wrap(function _callee2$(_context2) {
                  while (1) {
                    switch ((_context2.prev = _context2.next)) {
                      case 0:
                        wrappedComponentProps = {
                          pageProps: {},
                        };

                        if (!WrappedComponent.getInitialProps) {
                          _context2.next = 5;
                          break;
                        }

                        _context2.next = 4;
                        return WrappedComponent.getInitialProps(ctx);

                      case 4:
                        wrappedComponentProps = _context2.sent;

                      case 5:
                        if (typeof wrappedComponentProps.pageProps === 'undefined') {
                          consoleMessage(
                            'error',
                            'If you have a getInitialProps method in your custom _app.js file, you must explicitly return pageProps. For more information, see: https://github.com/zeit/next.js#custom-app'
                          );
                        }
                        /*
                    Initiate vars to return
                  */

                        req = ctx.ctx.req;
                        initialI18nStore = {};
                        initialLanguage = null;
                        i18nServerInstance = null;
                        /*
                    Step 1: Determine initial language
                  */

                        if (!(req && req.i18n)) {
                          _context2.next = 16;
                          break;
                        }

                        initialLanguage = (0, _utils.lngFromReq)(req);
                        /*
                    Perform a lang change in case we're not on the right lang
                  */

                        _context2.next = 14;
                        return req.i18n.changeLanguage(initialLanguage);

                      case 14:
                        _context2.next = 17;
                        break;

                      case 16:
                        if (Array.isArray(i18n.languages) && i18n.languages.length > 0) {
                          initialLanguage = i18n.language;
                        }

                      case 17:
                        /*
                    Step 2: Determine namespace dependencies
                  */
                        namespacesRequired = config.ns;

                        if (Array.isArray(wrappedComponentProps.pageProps.namespacesRequired)) {
                          namespacesRequired = wrappedComponentProps.pageProps.namespacesRequired;
                        } else {
                          consoleMessage(
                            'warn',
                            'You have not declared a namespacesRequired array on your page-level component: '.concat(
                              ctx.Component.displayName || ctx.Component.name || 'Component',
                              '. This will cause all namespaces to be sent down to the client, possibly negatively impacting the performance of your app. For more info, see: https://github.com/isaachinman/next-i18next#4-declaring-namespace-dependencies'
                            )
                          );
                        }
                        /*
                    We must always send down the defaultNS, otherwise
                    the client will trigger a request for it and issue
                    the "Did not expect server HTML to contain a <h1> in <div>"
                    error
                  */

                        if (typeof config.defaultNS === 'string' && !namespacesRequired.includes(config.defaultNS)) {
                          namespacesRequired.push(config.defaultNS);
                        }
                        /*
                    Step 3: Perform data fetching, depending on environment
                  */

                        if (!(req && req.i18n)) {
                          _context2.next = 26;
                          break;
                        }

                        /*
                    Detect the languages to load based upon the fallbackLng configuration
                  */
                        fallbackLng = config.fallbackLng;
                        languagesToLoad = (0, _utils.lngsToLoad)(initialLanguage, fallbackLng, config.otherLanguages);
                        /*
                    Initialise the store with the languagesToLoad and
                    necessary namespaces needed to render this specific tree
                  */

                        languagesToLoad.forEach(function (lng) {
                          initialI18nStore[lng] = {};
                          namespacesRequired.forEach(function (ns) {
                            initialI18nStore[lng][ns] = (req.i18n.services.resourceStore.data[lng] || {})[ns] || {};
                          });
                        });
                        _context2.next = 30;
                        break;

                      case 26:
                        if (!(Array.isArray(i18n.languages) && i18n.languages.length > 0)) {
                          _context2.next = 30;
                          break;
                        }

                        _context2.next = 29;
                        return clientLoadNamespaces(i18n.languages[0], namespacesRequired);

                      case 29:
                        initialI18nStore = i18n.store.data;

                      case 30:
                        /*
                    Step 4: Overwrite i18n.toJSON method to be able to serialize the instance
                  */
                        if (req && req.i18n) {
                          req.i18n.toJSON = function () {
                            return null;
                          };

                          i18nServerInstance = req.i18n;
                        }
                        /*
                    `pageProps` will get serialized automatically by NextJs
                  */

                        return _context2.abrupt(
                          'return',
                          _objectSpread(
                            {
                              initialI18nStore: initialI18nStore,
                              initialLanguage: initialLanguage,
                              i18nServerInstance: i18nServerInstance,
                            },
                            wrappedComponentProps
                          )
                        );

                      case 32:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })
            );

            function getInitialProps(_x2) {
              return _getInitialProps.apply(this, arguments);
            }

            return getInitialProps;
          })(),
        },
      ]
    );
    return AppWithTranslation;
  })(_react['default'].Component);

  return (0, _hoistNonReactStatics['default'])((0, _router.withRouter)(AppWithTranslation), WrappedComponent, {
    getInitialProps: true,
  });
};

exports.appWithTranslation = appWithTranslation;
